import { connect } from 'react-redux'
import { initTwoFactorEnabled, initiate2FASetup, verify2FASetup, disable2FA } from '../../actions/two_factor_actions'

const mapStateToProps = (state) => {
  return {
    loading: state.twoFactorSetup?.loading,
    twoFactorEnabled: state.twoFactorSetup?.twoFactorEnabled,

    otpSecret: state.twoFactorSetup?.otpSecret,
    qrCodeUrl: state.twoFactorSetup?.qrCodeUrl,

    error: state.twoFactorSetup?.error,
    success: state.twoFactorSetup?.success,
    backupCodes: state.twoFactorSetup?.backupCodes || null,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    initTwoFactorEnabled: (isEnabled) => dispatch(initTwoFactorEnabled(isEnabled)),
    initiate2FASetup: () => dispatch(initiate2FASetup()),
    verify2FASetup: (otpCode) => dispatch(verify2FASetup(otpCode)),
    disable2FA: () => dispatch(disable2FA()),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)
